import { render, staticRenderFns } from "./DocumentwithName.vue?vue&type=template&id=5e935484&scoped=true"
import script from "./DocumentwithName.vue?vue&type=script&lang=js"
export * from "./DocumentwithName.vue?vue&type=script&lang=js"
import style0 from "./DocumentwithName.vue?vue&type=style&index=0&id=5e935484&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e935484",
  null
  
)

export default component.exports